import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";

const placeAnOrder = async (data: any) => {
  return await axiosInstance.post("orders", data);
};

const usePlaceAnOrder = () => {
  return useMutation({
    mutationFn: (data: any) => placeAnOrder(data),
    mutationKey: ["quotes"],
  });
};
export default usePlaceAnOrder;
